import { EstadoVerificacion } from '@/shared/model/enumerations/estado-verificacion';

export default function resolveEstadoVerificacionVariant(estado: EstadoVerificacion) {
  switch (estado) {
    case EstadoVerificacion.COMPLETA:
      return 'success';
    case EstadoVerificacion.PENDIENTE:
      return 'warning';
    default:
      return 'warning';
  }
}
